import { getConsultation } from "./getConsultation";
import { postConsultation } from "./postConsultation";
import { deleteConsultation } from "./deleteConsultation";

export const consultationApi = {
  getConsultation,
  postConsultation,
  deleteConsultation
};
